var COLA_STATUS = {
  ERROR: 0,
  OK: 1,
  UNAUTHORISED: 2,
  ADDITIONAL_UNAVAILABLE: 3
};
var FIELD = {
  NEXT_PAYMENT_AMOUNT: '[nextPaymentAmount]',
  NEXT_PAYMENT_DATE: '[nextPaymentDate]',
  PAY_NOW_AMOUNT: '[payNowAmount]',
  PENALTY_AMOUNT: '[penaltyAmount]',
  EXTENSION_AMOUNT_7: '[loanExtensionAmount]',
  OVERDUE_DAYS: '[overdueDays]',
  CLIENT_APP_RESOLUTION_MESSAGE: '[clientAppResolutionMessage]',
  APP_CREDIT_LIMIT: '[appCreditLimit]',
  LATEST_PAYMENT_DATE: '[latestPaymentDate]',
  LATEST_PAYMENT_DATE_ZP: '[latestPaymentDateZp]',
  LATEST_PAYMENT_AMOUNT: '[latestPaymentAmount]',
  LATEST_PAYMENT_AMOUNT_ZP: '[latestPaymentAmountZp]',
  CLIENT_NUMBER: '[clientNumber]',
  LOAN_NUMBER: '[loanNumber]',
  BANK_ACCOUNT: '[bankAccount]',
  DISCOUNT_TYPE: '[discountType]',
  EXTENSION_AMOUNT_14: '[loanExtensionAmount14]',
  EXTENSION_AMOUNT_30: '[loanExtensionAmount30]',
  DUE_DATE: '[dueDate]'
};
var WHITELISTED_FIELDS = [FIELD.NEXT_PAYMENT_AMOUNT, FIELD.NEXT_PAYMENT_DATE, FIELD.PAY_NOW_AMOUNT, FIELD.PENALTY_AMOUNT, FIELD.EXTENSION_AMOUNT_7, FIELD.OVERDUE_DAYS, FIELD.CLIENT_APP_RESOLUTION_MESSAGE, FIELD.APP_CREDIT_LIMIT, FIELD.LATEST_PAYMENT_DATE, FIELD.LATEST_PAYMENT_AMOUNT, FIELD.CLIENT_NUMBER, FIELD.LOAN_NUMBER, FIELD.BANK_ACCOUNT, FIELD.DISCOUNT_TYPE, FIELD.EXTENSION_AMOUNT_14, FIELD.EXTENSION_AMOUNT_30, FIELD.DUE_DATE, FIELD.LATEST_PAYMENT_DATE_ZP, FIELD.LATEST_PAYMENT_AMOUNT_ZP];
export { COLA_STATUS, FIELD, WHITELISTED_FIELDS };